import {createReducer} from '@reduxjs/toolkit';
import {setDateRange} from '../../actions/search.js';

const now = new Date();

const end = new Date(
  now.getUTCFullYear(),
  now.getUTCMonth(),
  now.getUTCDate(),
  23,
  59,
  59,
);

const start = new Date(now);
start.setUTCMonth(now.getUTCMonth() - 6);
start.setUTCDate(1);
start.setUTCHours(0, 0, 0, 0);

export const defaultState = [start, end];

export default createReducer(defaultState, builder => {
  builder.addCase(setDateRange, (state, {payload}) => payload);
});
